export const LIST_BANK_HUB = 'LIST_BANK_HUB';
export const GET_BANK_ACCOUNT_HOLDER = 'GET_BANK_ACCOUNT_HOLDER';
export const CONNECT_BANK_HUB = 'CONNECT_BANK_HUB';
export const SUBMIT_OTP_CONNECT = 'SUBMIT_OTP_CONNECT';
export const RESEND_OTP_CONNECT = 'RESEND_OTP_CONNECT';

export const SUBMIT_OTP_DELETE = 'SUBMIT_OTP_DELETE';
export const REQUEST_OTP_DELETE = 'REQUEST_OTP_DELETE';
